// extracted by mini-css-extract-plugin
export default {"root":"E_vQoaF5cluiifMUM0ko","col1":"HYjFNNP190_h_Fp8xNt8","personName":"M06IdkFddtKt8_73Mcm_","phone":"KhnP_wazID6TLWRS0ZJw","placeHolderShimmer":"GQEuRM_LRrfy_eVavz6t"};